import { Component, OnInit, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { MenuItem, LazyLoadEvent } from 'primeng/api';
import { TableMeta } from './models/table-meta.model';
import { ColumnsMeta } from './models/columns-meta.model';
import ResolveFieldData from './helpers/resolve-field-data';
import { Account } from './models/account.model';
import { TranslationService } from 'projects/dop-core/src/public-api';
import { BabelService } from 'src/app/shared/data-service/babel.service';

class Filter {
  pageNumber = 1;
  pageSize = 10;
  sortingColumn: string;
  sortDirection = 0;
  searchTerm = '';
}

@Component({
  selector: 'dop-table',
  templateUrl: './dop-table.component.html',
  styleUrls: ['./dop-table.component.scss']
})
export class DopTableComponent implements OnInit {

  @ViewChild('gridTable', { static: true }) gridTable: Table;

  // Has table meta data including following properties
  // displayGlobalSearch, displayCheckBox, displayContextMenu
  // displayKebabMenu, editMenu, deleteMenu, showAccountSearch, displayCreateButton...
  @Input() tableMeta: TableMeta;

  // Has column meta data including following properties
  // field: string, header: string, sortable: bool, selectable: bool, displayIcon: bool...
  @Input() columnsMeta: ColumnsMeta[];

  // Set value to true if you want to disable the search (used when account search is enabled)
  @Input() disableGrid = false;

  // Set the default sorting column, or by default it will take the first field in the table
  @Input() defaultSortColumn: string;

  // Set the Display Text for the Create Button
  @Input() createButtonText = 'vbeiCreate';

  // Set the Display Text for the Extra Create Button
  @Input() extraCreateButtonText = 'vbeiCreate';

  // Set the Place Holder for global search filter input
  @Input() placeHolderText = 'vbeiSearch';

  // Set the options for global filter
  @Input() globalFilterOptions: MenuItem[];
  @Input() globalDropdownOptions: any[];

  @Input() splitOptions: any;

  @Input() isPending: boolean;

  // Set the data of the grid to be displayed
  get gridData(): any {
    return this.gridDataDto;
  }
  @Input()
  set gridData(val: any) {
    this.gridDataDto = val;
    this.flag = true;
    this.selectedTableRows = this.tableMeta.retainRowSelection ? this.selectedTableRows : [];
    this.onCheckBoxChange();
  }

  // Set the total Records Property used to display the no of page numbers
  @Input() totalRecords: any;

  // Set user details if needed (to get default account code)
  @Input() user: any;

  // use getter setter to define the property
  // Set the accounts property which is used to display drop down in account search
  get accounts(): any {
    return this.accountsDto;
  }
  @Input()
  set accounts(val: any) {
    if (val) {
      this.setAccountData(val);
    } else {
      this.isAccountExist = true;
    }
  }

  // use getter setter to define the property
  // Set the StoreData property which is used for opening grid with previous state
  get storeData(): any {
    return this.storeDataDto;
  }
  @Input()
  set storeData(val: any) {
    if (val) {
      this.storeDataDto = val;
    }
  }

  // use this field to handle validation related to the grid when the data is loaded or not
  @Input() isDataLoaded = true;

  // Set Import Icon Tool Tip Text
  @Input() importToolTip = 'vbeiImport';

  // Set Export Icon Tool Tip Text
  @Input() exportToolTip = 'vbeiExport';

  // Set Export Icon Tool Tip Text
  @Input() disableImportExport = true;

  // Set the sort order of Default Sorting Column
  @Input() sortOrder = 1;

  // Show Loading Icon instead of Kebab Menu
  @Input() showLoadingKebab = false;

  // Set the custom error message if grid is empty
  @Input() emptyGridErrorMessage = 'vbeiNoResultsFound';

  // Set the custom error message if grid is empty
  @Input() toolTipTextForDelete = 'vbeiDelete';

  // Event Triggered when there is change in the table filter
  // returns the filter object contain following properties
  // pageNo, offset, sortingColumn, sortingOrder, search
  @Output() filterChangeEvent = new EventEmitter<Filter>();

  @Output() globalFilterChangeEvent = new EventEmitter<Filter>();
  @Output() globalDropdownChangeEvent = new EventEmitter<Event>();

  // Event Triggered when there is row selection done, if the cell has selectable property in columnsMeta
  // returns the data(object) present in the row
  @Output() rowSelectedEvent = new EventEmitter<any>();

  // Event Triggered when there is row focus, if the cell has selectable property in columnsMeta
  // returns the data(object) present in the row
  @Output() rowFocusEvent = new EventEmitter<any>();

  // Event Triggered when there is a row deletion from the context menu, kebab menu, checkbox selection and deletion
  // returns the data(object) of the row to be deleted
  @Output() rowDeletionEvent = new EventEmitter<any>();

  // Event Triggered when there is a checkbox selection
  @Output() selectedRowChangeEvent = new EventEmitter<any>();

  // Event Triggered when text is entered in the account search input box
  // returns the search text entered
  @Output() accountSearchEvent = new EventEmitter<any>();

  // Event Triggered when the account is selected from the dropDown
  // returns the selected account
  @Output() accountSelectEvent = new EventEmitter<any>();

  // Event Triggered when the Create button is clicked
  @Output() createButtonEvent = new EventEmitter<any>();

  // Event Triggered when the Create button is clicked
  @Output() extraCreateButtonEvent = new EventEmitter<any>();

  // Event Triggered to send the Grid State to the Parent
  @Output() gridState = new EventEmitter<any>();

  // Event Triggered to send the Grid State to the Parent
  @Output() defaultValueRowEditEvent = new EventEmitter<any>();

  // Event Triggered when the Upload button is clicked
  @Output() uploadButtonEvent = new EventEmitter<any>();

  // Event Triggered when the Download button is clicked
  @Output() downloadButtonEvent = new EventEmitter<any>();

  // Event Triggered when Create new Order Button Is Clicked, if the cell has selectable property in columnsMeta
  // returns the data(object) present in the row
  @Output() createOrderSelectedEvent = new EventEmitter<any>();

  //Event triggered when edit schedule button clicked
  @Output() EditScheduleEvent = new EventEmitter<any>();

  private storeDataDto: any;
  private accountsDto: any;
  private gridDataDto: any;
  private gridStateDto: any;

  filter: Filter;
  selectedTableRows: any[] = [];
  noOfSelectedTableRows: number;
  contextMenuOptions: MenuItem[] = [];
  deleteRowData: any;
  paginationState: any = { first: 0, rows: 10 };
  previousSearch = '';
  accountSearch: any;
  dropDownAccountSelected: any;
  accountCode: string;
  isAccountExist = true;
  searchText = '';
  booleanTypeValues = [{ label: 'True', value: 'True' }, { label: 'False', value: 'False' }];
  flag = false;
  math = Math;
  selectedDropdownOption: any;

  constructor() {
    this.accountCode = '';
  }

  ngOnInit() {
    if (this.disableGrid) {
      this.gridData = [];
    }
    this.filter = new Filter();
    if (this.tableMeta.displayContextMenu) {
      this.setUpContextMenu();
    }
    if (!this.defaultSortColumn) {
      this.defaultSortColumn = this.columnsMeta[0].field;
    }

    if (this.storeDataDto) {
      this.setUpGridState(this.storeDataDto);
    }
  }

  setAccountData(accountsData: any) {
    this.accountsDto = accountsData;
    this.isAccountExist = this.accountsDto.length > 0;
    if (this.tableMeta.isCustomerUser) {
      if (this.accounts.length === 1) {
        this.dropDownAccountSelected = this.accounts[0];
        this.accountCode = this.dropDownAccountSelected.code;
        setTimeout(() => { this.disableGrid = false; });
        this.sendAccountSelectedToParent(this.dropDownAccountSelected);
      }
      if (this.user.defaultAccountCode) {
        const defaultAccountIndex = this.accounts.findIndex((c: any) => c.code === this.user.defaultAccountCode);
        this.dropDownAccountSelected = this.accounts[defaultAccountIndex];
        this.accounts.splice(defaultAccountIndex, 1);
        this.accounts.unshift(this.dropDownAccountSelected);
        this.accountCode = this.dropDownAccountSelected.code;
        setTimeout(() => { this.disableGrid = false; });
        this.sendAccountSelectedToParent(this.dropDownAccountSelected);
      }
      this.accounts.forEach((x: any) => {
        x.custom = this.customField(x);
      });
    }
    if (!this.isAccountExist) {
      this.gridData = [];
      setTimeout(() => { this.disableGrid = true; });
      this.totalRecords = 0;
      this.accountCode = '';
      this.filter.searchTerm = null;
      this.searchText = null;
    }
  }

  setUpContextMenu() {
    this.contextMenuOptions = [];
    if (this.tableMeta.displayCreateMenu) {
      this.contextMenuOptions.push({
        label: TranslationService.translate('vbeiCreateNewOrder'),
        icon: 'ei ei-cart-plus',
        command: () =>
          this.onSelectingRow(this.gridTable.contextMenuSelection)
      });
    }
    if (this.tableMeta.displayEditMenu) {
      this.contextMenuOptions.push({
        label: TranslationService.translate('vbeiEdit'),
        icon: 'ei ei-pencil',
        command: () =>
          this.onSelectingRow(this.gridTable.contextMenuSelection)
      });
    }
    if (this.tableMeta.displayDeleteMenu) {
      this.contextMenuOptions.push({
        label: TranslationService.translate('vbeiDelete'),
        icon: 'ei ei-trash2',
        command: () => this.deleteTableRow(this.gridTable.contextMenuSelection)
      });
    }
  }

  lazyLoadData(event: LazyLoadEvent) {
    if (event.filters.global && event.filters.global.value.length < 3) {
      return;
    }
    this.filter.searchTerm = '';
    // Setting the filter, sortColumn, sortingOrder, offset variables
    if (event.filters.global) {
      this.filter.searchTerm = event.filters.global.value;
    }
    if (event.sortField) {
      this.filter.sortingColumn = event.sortField;
    }
    if (event.sortOrder) {
      this.filter.sortDirection = event.sortOrder > 0 ? 0 : 1;
    }
    this.filter.pageSize = this.paginationState.rows;

    // PageNo reset to 1 if filter is applied
    if (this.previousSearch !== this.filter.searchTerm) {
      this.filter.pageNumber = 1;
      this.paginationState.first = 0;
    } else {
      this.filter.pageNumber = (this.paginationState.first / this.paginationState.rows) + 1;
    }

    this.previousSearch = this.filter.searchTerm;

    // Making table event and pagination state in sync
    event.first = this.paginationState.first;
    event.rows = this.paginationState.rows;

    this.gridStateDto = event;
    this.sendGridStateToParent(event);
    this.sendFilterDataToParent();
  }

  paginate(event: any) {
    this.setPageSettings(event);
    this.sendFilterDataToParent();
    this.gridStateDto.first = event.first;
    this.gridStateDto.rows = event.rows;
    this.sendGridStateToParent(this.gridStateDto);
  }

  setPageSettings(event: any) {
    // event.first = Index of the first record
    // event.rows = Number of rows to display in new page
    // event.page = Index of the new page
    // event.pageCount = Total number of pages
    this.filter.pageSize = event.rows;
    this.filter.pageNumber = event.page + 1;

    // Updating the pagination variable on page change
    this.paginationState.first = event.first;
    this.paginationState.rows = event.rows;
  }

  onSelectAccount(event: Account) {
    this.flag = false;
    this.accountCode = event.code;
    this.searchText = '';
    this.sendAccountSelectedToParent(event);
    this.sendGridStateToParent(this.gridTable.filters);
  }

  accountSelected() {
    this.flag = false;
    if (this.dropDownAccountSelected) {
      this.accountCode = this.dropDownAccountSelected.code;
      this.searchText = '';
      this.sendAccountSelectedToParent(this.dropDownAccountSelected);
    } else {
      this.resetProductCategoryTable();
    }
  }

  resetProductCategoryTable() {
    this.accountCode = '';
    this.searchText = '';
    this.isAccountExist = true;
    this.sendAccountSelectedToParent(null);
    this.sendGridStateToParent(this.gridTable.filters);
  }

  customField(account: any) {
    return account.code + ' - ' + account.name + ' - ' + account.address.city;
  }

  onCheckBoxChange() {
    this.noOfSelectedTableRows = this.selectedTableRows.length;
    this.selectedRowChangeEvent.emit(this.selectedTableRows);
  }

  resolveFieldData(data: any, field: string, isCss: boolean=false, isRowSpanRequired: boolean=false) {
    if (field === 'status' && isCss)
    {
      const statusVal = ResolveFieldData.resolve(data, field);
      return this.getTagForTranslatedValue(statusVal);
    }
    if (field === 'runFrequencyDetail' && isRowSpanRequired)
    {
      const displaydata = ResolveFieldData.resolve(data, field);
      return displaydata.split('\\n');
    }
    return ResolveFieldData.resolve(data, field);
  }

  getTagForTranslatedValue(statusVal: string){
    const tag = BabelService.getListOfTranslationsForUserLanguage();
    if(tag['oleiStatusSubmitted'] === statusVal)
    {
      return 'submitted';
    }
    else if(tag['vbeiStatus@Lab'] === statusVal)
    {
      return '_lab';
    }
    else if (tag['vbeiPending'] === statusVal)
    {
      return 'pending';
    }
    else if (tag['vbeiStatusNotSentError'] === statusVal)
    {
      return 'notsenterror_submitted';
    }
    else if(tag['vbeiStatusNegativeAckReceived'] === statusVal)
    {
      return 'negativeackreceived_submitted';
    }
    else if(tag['vbeiActive'] === statusVal){
      return 'active';
    }
    else if(tag['vbeiInactive'] === statusVal){
      return 'inactive';
    }
  }

  setUpGridState(state: any) {
    if (state.account) {
      this.accountSearch = state.account;
      state.account.isFromState = true;
      this.onSelectAccount(state.account);
    }
    if (state.event.filters) {
      this.searchText = state.event.filters.global ? state.event.filters.global.value : '';
      this.gridTable.filters = state.event.filters;
      this.defaultSortColumn = state.event.sortField;
      this.sortOrder = state.event.sortOrder;
    }
  }

  checkValidation() {
    if (this.isDataLoaded) {
      if (this.flag) {
        if (this.tableMeta.showAccountSearch) {
          if (this.accountCode.length > 0 && (this.totalRecords < 1 || this.totalRecords === undefined)) {
            return true;
          }
        } else if (this.totalRecords < 1 || this.totalRecords === undefined) {
          return true;
        }
      }
    }
  }

  // Emits event to parent if Create Button is clicked
  onCreateButtonClick() {
    this.createButtonEvent.emit();
  }

  // Emits event to parent if Create Button is clicked
  onExtraCreateButtonClick() {
    this.extraCreateButtonEvent.emit();
  }

  // Emits the filter object to the parent on any change to grid state
  sendFilterDataToParent() {
    this.filterChangeEvent.emit(this.filter);
  }

  // Emits the filter object to the parent on any change to grid state
  sendGlobalFilterDataToParent() {
    this.globalFilterChangeEvent.emit(this.filter);
  }

  // Emits the filter object to the parent on any change to grid state
  sendGlobalDropdownDataToParent(event: Event) {
    this.globalDropdownChangeEvent.emit(event);
  }

  // Emits the row Data to the parent when a row is clicked
  onSelectingRow(rowData: any) {
    this.rowSelectedEvent.emit(rowData);
  }

  // Emits the row Data to the parent when a row is clicked
  onFocusRow(rowData: any) {
    this.rowFocusEvent.emit(rowData);
  }

  // Emits the row Data to the parent when a Create New Order Button Is clicked
  onCreateNewOrderClick(rowData: any) {
    this.createOrderSelectedEvent.emit(rowData);
  }

  // Emits the rows selected to be deleted to the parent
  onMultipleDelete() {
    this.rowDeletionEvent.emit(this.selectedTableRows);
  }

  // Emits the row selected to be deleted to the parent
  deleteTableRow(rowData: any) {
    this.rowDeletionEvent.emit([rowData]);
  }

  // Emits the search text based on which account search should happen
  fillAccounts() {
    this.accountSearchEvent.emit(this.accountSearch);
  }

  // Emits the account which has been selected from the drop down
  sendAccountSelectedToParent(account: any) {
    this.accountSelectEvent.emit(account);
  }

  // Emits the current grid state to the parent
  sendGridStateToParent(event: any) {
    this.gridState.emit(event);
  }

  // Emits the row data which has been edited
  changeDefaultValue(rowData: any) {
    this.defaultValueRowEditEvent.emit(rowData);
  }

  // Emits event to parent if Upload Button is clicked
  uploadWindow() {
    this.uploadButtonEvent.emit();
  }

  // Emits event to parent if Download Button is clicked
  downloadWindow() {
    this.downloadButtonEvent.emit();
  }

  //Emits event to edit schedule
  onEditScheduleButtonClick(rowData: any){
    this.EditScheduleEvent.emit(rowData);
  }
}
